/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "cancel": [{
    "type": 0,
    "value": "Cancel"
  }],
  "default_abandonment_body": [{
    "type": 0,
    "value": "If you leave this page you'll lose your changes."
  }],
  "default_abandonment_header": [{
    "type": 0,
    "value": "Leave page?"
  }],
  "leave_page": [{
    "type": 0,
    "value": "Leave page"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var DefaultTranslationComp = Object.assign(TranslationProviderComponent, {
  translations
});

export { DefaultTranslationComp as D };
//# sourceMappingURL=en-US-V8FqlKqe.js.map
